<template>
  <header id="header"><!--header-->
		<div class="header_top"><!--header_top-->
			<div class="container">
				<div class="row">
					<div class="col-sm-6">
						<div class="contactinfo">
							<ul class="nav nav-pills">
								<li><a href="#"><i class="fa fa-phone"></i> (14) 3415-2817</a></li>
								<li><a href="#"><i class="fa fa-envelope"></i> usinagemsaraiva@gmail.com</a></li>
							</ul>
						</div>
					</div>
					<div class="col-sm-6">
						<div class="social-icons pull-right">
							<ul class="nav navbar-nav">
								<li><a href="https://www.facebook.com/Usinagem-Saraiva-240332769385228/?ref=bookmarks "><i class="fab fa-facebook"></i></a></li>
								<li><a href="https://www.instagram.com/usinagemsaraiva/?hl=pt-br"><i class="fab fa-instagram"></i></a></li>
								<li><a href="https://www.linkedin.com/company/usinagem-saraiva/about/?viewAsMember=true"><i class="fab fa-linkedin"></i></a></li>
								<!-- <li><a href="#"><i class="fab fa-dribbble"></i></a></li> -->
								<!-- <li><a href="#"><i class="fab fa-google-plus"></i></a></li> -->
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div><!--/header_top-->
		
		<!-- <div class="header-middle">
			<div class="container">
				<div class="row">
					<div class="col-sm-4">
						<div class="logo pull-left">
							<a href="index.html"><img src="images/home/logo.png" alt="" /></a>
						</div>
					</div>
				</div>
			</div>
		</div> -->
	
		<div class="header-middle" style=""><!--header-bottom-->
			<div class="container">
				<div class="row">
					<div class="col-12 col-md-4">
						<div class="logo pull-left">
							<a href="#/home"><img src="images/home/logo.png" alt="" style="width: 75%;" /></a>
						</div>
					</div>
					<div class="col-9 col-md-7" style="margin-top: 4.5%;">
						<div class="navbar-header">
							<button type="button" class="navbar-toggle" data-toggle="collapse" data-target=".navbar-collapse">
								<span class="sr-only">Toggle navigation</span>
								<span class="icon-bar"></span>
								<span class="icon-bar"></span>
								<span class="icon-bar"></span>
							</button>
						</div>
						<div class="mainmenu pull-left">
							<ul class="nav navbar-nav collapse navbar-collapse">
								<li><router-link to="/home" :class="classe('PaginaInicial')">Home</router-link></li>
								<li><router-link to="/sobre" :class="classe('Sobre')">Quem Somos</router-link></li>
								<li class="dropdown">
									<router-link to="/produtos/" :class="classe('Produtos')">Produtos
										<!-- <i class="fa fa-angle-down"></i> -->
									</router-link>
										<!-- <ul role="menu" class="sub-menu">
											<li v-for="cat in categorias"><a @click="$router.go('home')">{{cat.nome}}</a></li>
										</ul> -->
								</li> 
								<li><router-link to="/servicos" :class="classe('Servicos')">Servicos</router-link></li>
								<li><router-link to="/contato" :class="classe('Contato')">Contato</router-link></li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div><!--/header-bottom-->
	</header><!--/header-->
</template>
<script>

export default {
  name: 'Header',
  components: {
  },
  data() {
    return {
    }
  },
  created() {
    
  },
  methods: {
	  classe(pag) {
		  return pag == this.$route.name ? 'active' : ''
	  }
  }
}
</script>